// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__18nvZ","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__1YuyT","gfeWrapper":"CalendarEvent_gfeWrapper__2FoZT"};